// extracted by mini-css-extract-plugin
export var backdropBlur = "_kr-0";
export var contentCard = "_kr-5";
export var frame = "_kr-2";
export var image = "_kr-4";
export var imagePane = "_kr-3";
export var modal = "_kr-1";